/**
* In this file contains all Form Validation services Handeling
**/

import * as Yup from 'yup';
import moment from 'moment';

/**
* Assign Validation for field
* @fields pass the name and Validation type in Object format like { name: 'first_name', validation: Yup.string().required('Field is required') }
**/
const createSchema = (fields) => {
  const schema = {};
  fields.forEach((field) => {
    schema[field.name] = field.validation;
  });
  return Yup.object().shape(schema);
};

/**
* Form Validation function
* @values pass the input field value
* @fields pass the name and Validation type in Object format like { name: 'first_name', validation: Yup.string().required('Field is required') }
**/
const validate = async (values, fields) => {
  const validationSchema = createSchema(fields);
  try {
    await validationSchema.validate(values, { abortEarly: false });
    return {};
  } catch (error) {
    const errors = {};
    if (error.inner) { 
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
    }
    return errors;
  }
};

/**
* This function used to Validation OTP
* @values pass the entered otp in array format
**/
const validateOTP = async (values) => {
  for (let i = 0; i < values.length; i++) {
    if (isNaN(values[i]) || values[i] === '') {
      return false; // return false if any field is not a number or is empty
    }
  }
  return true; // return true if all fields are valid
};

/**
* This function used to Find Duplicate indices in a single array
* @array pass the full array value
* @key1 pass the name of the Object want to validate the duplicate
* @key2 pass the name of the Object want to validate the duplicate
**/
const findDuplicateIndices = async (array, key1, key2) => {
  const duplicateIndices = [];
  const seenObjects = {};
  array.forEach((item, index) => {
    const itemKey = JSON.stringify({
      [key1]: item[key1]
	  //,      [key2]: item[key2]
    });
    if (seenObjects[itemKey] !== undefined) {
      const existingIndex = seenObjects[itemKey];
      if (!duplicateIndices.includes(existingIndex)) {
        duplicateIndices.push(existingIndex);
      }
      duplicateIndices.push(index);
    } else {
      seenObjects[itemKey] = index;
    }
  });

  return duplicateIndices;
};

	// Function to checking Time and Days overlap in hospital schedules
	const checkScheduleOverlap = (existingSchedules, newSchedule, indexToExclude) => {
		const { days, startTime, endTime, physician } = newSchedule;

		// Convert the new schedule start and end times to moment objects
		const newStartTime = moment(startTime, "HH:mm");
		const newEndTime = moment(endTime, "HH:mm");

		// Loop through each existing schedule to check for overlaps
		return existingSchedules.some((schedule, index) => {
			// Skip the current schedule if its index matches the one we are adding/editing
			if (index === indexToExclude) return false;

			const scheduleDays = schedule.days;  // Days of the existing schedule
			const scheduleStartTime = moment(schedule.startTime, "HH:mm");  // Start time of the existing schedule
			const scheduleEndTime = moment(schedule.endTime, "HH:mm");  // End time of the existing schedule

      // Check if the physicians are the same
      const samePhysician = schedule.physician === physician;

			// Check if there is any overlap in days
			const hasOverlapDays = days.some(day => scheduleDays.includes(day));

			// Check if the times overlap
			const timeConflict = newStartTime.isBefore(scheduleEndTime) && newEndTime.isAfter(scheduleStartTime);

			// Ensure both the days and the times must overlap for the conflict to be true
			return samePhysician && hasOverlapDays && timeConflict;
		});
	};

export {validate,validateOTP,findDuplicateIndices,checkScheduleOverlap};


